import script from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-room-default.vue?vue&type=script&setup=true&lang=ts"

import "./message-room-default.vue?vue&type=style&index=0&id=0d08bce4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d08bce4"]])

export default __exports__